import { get } from 'lodash';
import store from '../../store/store';
import {
  FETCH_REWARD_PROGRAM_RULES,
  FETCH_BRAND_DEAL_DATA,
  CLEAR_BRAND_DEAL_DATA,
  FETCH_BRAND_OUTLETS,
  FETCH_GUEST_COUPONS,
  FETCH_REWARD_POINTS_TRANSACTIONS,
  BRAND_REWARD_GUEST_DETAILS,
  FETCH_REWARD_DEALS,
  CLEAR_GUEST_COUPONS,
  FETCH_REWARD_POINTS,
  UPDATE_GUEST_COUPON_FILTER,
  UPDATE_REWARD_POINT_TRANSACTION_FILTER,
  DISPATCH_CALLBACK_URL,
  SIGNUP_DETAILS,
  FETCH_VIP_PASSES,
  FETCH_VIP_PASS_DATA,
  FETCH_VIP_PASS_COUPONS,
  CLEAR_VIP_PASS_DATA,
  FETCH_PASS_MEMBERSHIP_BY_ID,
  SUBSCRIBE_PASS_MEMBERSHIP,
  FETCH_PASS_MEMBERSHIPS,
  CLEAR_PASS_MEMBERSHIPS,
  DISPATCH_SUBSCRIBED_MEMBERSHIP,
  FETCH_ALL_SUB_BRANDS,
  UPDATE_PAY_EARN_DATA,
  UPDATE_BOOK_TABLE_DATA,
  FETCH_GUEST_BOGO_COUPONS,
  FETCH_GUEST_LAST_ORDER,
  VALIDATE_REFERRAL_CODE,
  FETCH_REFERRAL_CODE,
  FETCH_REFERRAL_DEALS,
  FETCH_NEAYBY_HOOD,
  FETCH_HOOD_ITEMS,
  ADD_TO_CART,
  REMOVE_FROM_CART,
  CLEAR_CART,
  CLEAR_CART_SELECTION_STATE,
  PLACE_BOOKING,
  SEARCH_GROUPED_SLOTS,
  REPLACE_GROUPED_CART,
  CHECKOUT_BOOKING_ORDER,
  CLEAR_GROUPED_CHECKOUT,
  UPDATE_GROUP_BOOKING_DRAFT,
  CLEAR_GROUP_BOOKING_DRAFT,
  FETCH_HOOD_ITEM_SLOTS,
  FETCH_CATEGORY_SLOTS,
  UPDATE_SERVICE_SELECTION,
  CLEAR_SERVICE_SELECTION,
  FETCH_BOOKING_DETAILS,
  FETCH_BOOKING_HISTORY,
  FETCH_BOOKING_ORDER_DETAILS,
  FETCH_HOODD_ITEMS_SLOTS,
  FETCH_USER_CONSENTS,
  UPDATE_USER_CONSENTS,
  FETCH_HOOD_ITEMS_CATALOGUE,
} from './actionType';
import { BEGIN_AJAX_CALL, END_AJAX_CALL } from '../actionType';
import { apiResponseCodes } from '../../constants/globals';

import { apiErrorResponseAction } from '../app.action';

import {
  fetchRewardProgramRulesApi,
  fetchDealByIdApi,
  fetchOutletDetailsApi,
  fetchGuestCouponsApi,
  fetchRewardPointsTransactionsApi,
  updateRewardGuestProfileApi,
  fetchRewardGuestDetailsApi,
  fetchBrandDealsApi,
  fetchRewardPointsApi,
  initiateDeleteAccountApi,
  initiateDeleteBrandGuestAccountApi,
  fetchVIPPassesApi,
  fetchVIPPassByIdApi,
  fetchVIPPassCouponsByIdApi,
  fetchPassMembershipByIdApi,
  subscribePassMembershipApi,
  fetchPassMembershipsApi,
  fetchAllSubBrandsApi,
  updatePaymentCartApi,
  paymentOrderPayApi,
  paymentOrderDetailsApi,
  fetchReservationAvailableSlotsApi,
  createTableReservationApi,
  fetchTableReservationDetailsApi,
  fetchGuestLastOrderApi,
  updatePaymentCartApiV2,
  paymentOrderPayApiV2,
  validateReferralCodeApi,
  fetchReferralCodeApi,
  generateReferralCodeApi,
  fetchReferralDealsApi,
  fetchExternalOfferDetailsApi,
  fetchExternalOffersApi,
  fetchNearByHoodApi,
  fetchHoodItemsByIdApi,
  fetchHoodItemsByCatalogueApi,
  onAddToCartApi,
  onRemoveFromCartApi,
  clearCartApi,
  placeBookingApi,
  searchGroupedSlotsApi,
  replaceGroupedCartApi,
  checkoutBookingOrderApi,
  initiateBookingOrderPaymentApi,
  fetchHoodItemSlotsApi,
  fetchCategorySlotsApi,
  fetchBookingHistoryApi,
  fetchBookingOrderDetailsApi,
  fetchBookingDetailsByIdApi,
  fetchBookingFeedbackOptionsApi,
  fetchBookingFeedbackStatusApi,
  createBookingFeedbackApi,
  fetchEarlierSlotsAvailableByHoodIdApi,
  fetchUserConsentsApi,
  updateUserConsentsApi,
  updateCartWithUserConsentApi,
} from '../../api/api';
import { isNativeWebView } from '../../utils/helpers';
import {
  APPLICABLE_HOOD_IDS,
  filterApplicableHoods,
  isApplicableHood,
  mergeApplicableHoodCatalogues,
} from '../../constants/applicableHoods';

const getApplicableRequestedHoodIds = ({ hoodId, hoodIds } = {}) => {
  const requestedIds = Array.isArray(hoodIds) ? hoodIds : hoodId ? [hoodId] : APPLICABLE_HOOD_IDS;
  return [...new Set(requestedIds.map(String).filter(isApplicableHood))];
};

export const beginAjaxCallAction = () => async (dispatch) => {
  dispatch({
    type: BEGIN_AJAX_CALL,
    showSpinner: true,
  });
};

export const endAjaxCallAction = () => async (dispatch) => {
  dispatch({
    type: END_AJAX_CALL,
    showSpinner: false,
  });
};

export const fetchGuestCouponsAction =
  ({ url, dispatchBogoCoupons }, withLoader = false) =>
  async (dispatch) => {
    try {
      withLoader && dispatch(beginAjaxCallAction());
      const guestCouponsResponse = await fetchGuestCouponsApi({ url })
        .then((response) => {
          dispatchBogoCoupons
            ? dispatch({
                type: FETCH_GUEST_BOGO_COUPONS,
                guestBogoCoupons: get(response, 'data', {}),
              })
            : dispatch({
                type: FETCH_GUEST_COUPONS,
                guestCoupons: get(response, 'data', {}),
              });
          return response;
        })
        .catch((errorResponse) => {
          dispatch(apiErrorResponseAction(get(errorResponse, 'response.data', {})));
          return get(errorResponse, 'response', {});
        });
      return guestCouponsResponse;
    } catch (error) {
      console.log(error);
    } finally {
      withLoader && dispatch(endAjaxCallAction());
    }
  };

export const checkGuestCouponsAction =
  ({ url }, withLoader = false) =>
  async (dispatch) => {
    try {
      withLoader && dispatch(beginAjaxCallAction());
      const guestCouponsResponse = await fetchGuestCouponsApi({ url })
        .then((response) => {
          return response;
        })
        .catch((errorResponse) => {
          dispatch(apiErrorResponseAction(get(errorResponse, 'response.data', {})));
          return get(errorResponse, 'response', {});
        });
      return guestCouponsResponse;
    } catch (error) {
      console.log(error);
    } finally {
      withLoader && dispatch(endAjaxCallAction());
    }
  };

export const clearGuestCouponsAction = () => async (dispatch) => {
  dispatch({
    type: CLEAR_GUEST_COUPONS,
    guestCoupons: {},
  });
};

export const fetchRewardProgramRulesAction =
  ({ brandId }, withLoader = false) =>
  async (dispatch) => {
    try {
      withLoader && dispatch(beginAjaxCallAction());
      const rewardProgramResponse = await fetchRewardProgramRulesApi({ brandId })
        .then((response) => {
          dispatch({
            type: FETCH_REWARD_PROGRAM_RULES,
            rewardRules: get(response, 'data', {}),
          });
          return response;
        })
        .catch((error) => {
          console.log(error);
        });
      return rewardProgramResponse;
    } catch (error) {
      console.log(error);
    } finally {
      withLoader && dispatch(endAjaxCallAction());
    }
  };

export const fetchDealByIdAction =
  ({ dealCode, guestId }) =>
  async (dispatch) => {
    try {
      const brandDealDetailResponse = await fetchDealByIdApi({ dealCode, guestId })
        .then((response) => {
          const brandDealDetail = get(response, 'data', {});
          dispatch({
            type: FETCH_BRAND_DEAL_DATA,
            brandDealDetail,
          });
          return response;
        })
        .catch((errorResponse) => {
          dispatch(apiErrorResponseAction(get(errorResponse, 'response.data', {})));
          return get(errorResponse, 'response', {});
        });
      return brandDealDetailResponse;
    } catch (err) {
      console.log(err);
    }
  };

export const clearBrandDealDataAction = () => async (dispatch) => {
  dispatch({
    type: CLEAR_BRAND_DEAL_DATA,
  });
};

export const fetchBrandOutletsAction =
  ({ url }) =>
  async (dispatch) => {
    try {
      const brandOutletsResponse = await fetchOutletDetailsApi({ url })
        .then((response) => {
          const brandOutlets = get(response, 'data', {});
          dispatch({
            type: FETCH_BRAND_OUTLETS,
            brandOutlets,
          });
          return response;
        })
        .catch((errorResponse) => {
          dispatch(apiErrorResponseAction(get(errorResponse, 'response.data', {})));
          return get(errorResponse, 'response', {});
        });
      return brandOutletsResponse;
    } catch (err) {
      console.error(err);
    }
  };

export const fetchRewardPointsTransactionAction =
  (requestBody, withLoader = false) =>
  async (dispatch) => {
    try {
      withLoader && dispatch(beginAjaxCallAction());
      const rewardPointsTransactionResponse = await fetchRewardPointsTransactionsApi(requestBody)
        .then((response) => {
          dispatch({
            type: FETCH_REWARD_POINTS_TRANSACTIONS,
            rewardPointTransactions: get(response, 'data', {}),
          });
          return response;
        })
        .catch((errorResponse) => {
          dispatch(apiErrorResponseAction(get(errorResponse, 'response.data', {})));
          return get(errorResponse, 'response', {});
        });
      return rewardPointsTransactionResponse;
    } catch (error) {
      console.log(error);
    } finally {
      withLoader && dispatch(endAjaxCallAction());
    }
  };

export const dispatchRewardGuestProfileAction = (data) => async (dispatch) => {
  dispatch({
    type: BRAND_REWARD_GUEST_DETAILS,
    rewardGuestDetails: data,
  });
};

export const updateRewardGuestProfileAction =
  (updateProfileReqBody, withLoader = true, sendEventToNative) =>
  async (dispatch) => {
    try {
      withLoader && dispatch(beginAjaxCallAction());
      const brandRewardGuestProfileResponse = await updateRewardGuestProfileApi(
        updateProfileReqBody,
      )
        .then((response) => {
          dispatch({
            type: BRAND_REWARD_GUEST_DETAILS,
            rewardGuestDetails: get(response, 'data', {}),
          });
          if (sendEventToNative && isNativeWebView) {
            let loginData = store.store.getState().authentication.loginData;
            let authData = store.store.getState().authentication.authData;

            const data = {
              eventType: {
                type: 'loginData',
                data: {
                  guest: loginData,
                  auth: authData,
                  rewardGuestDetails: get(response, 'data', {}),
                },
              },
            };
            window.ReactNativeWebView.postMessage(JSON.stringify(data));
          }
          return response;
        })
        .catch((errorResponse) => {
          dispatch(apiErrorResponseAction(get(errorResponse, 'response.data', {})));
          return get(errorResponse, 'response', {});
        });
      return brandRewardGuestProfileResponse;
    } catch (error) {
      console.log(error);
    } finally {
      withLoader && dispatch(endAjaxCallAction());
    }
  };

export const dispatchBrandGuestDataAction = (data) => async (dispatch) => {
  dispatch({
    type: BRAND_REWARD_GUEST_DETAILS,
    rewardGuestDetails: data,
  });
};

export const fetchRewardGuestDetailsAction =
  (requestBody, withLoader = false) =>
  async (dispatch) => {
    try {
      withLoader && dispatch(beginAjaxCallAction());
      const rewardGuestDetailsResponse = await fetchRewardGuestDetailsApi(requestBody)
        .then((response) => {
          dispatch({
            type: BRAND_REWARD_GUEST_DETAILS,
            rewardGuestDetails: get(response, 'data', {}),
          });
          if (isNativeWebView) {
            // ensure isNativeWebView is there, otherwise, web app might crash if is not there
            const brandGuestData = get(response, 'data', {});
            const data = {
              eventType: {
                type: 'brandGuestData',
                data: brandGuestData,
              },
            };
            window.ReactNativeWebView.postMessage(JSON.stringify(data));
          }
          return response;
        })
        .catch((errorResponse) => {
          dispatch(apiErrorResponseAction(get(errorResponse, 'response.data', {})));
          return get(errorResponse, 'response', {});
        });
      return rewardGuestDetailsResponse;
    } catch (error) {
      console.log(error);
    } finally {
      withLoader && dispatch(endAjaxCallAction());
    }
  };

export const fetchRewardDealsAction =
  ({ url }, withLoader = false) =>
  async (dispatch) => {
    try {
      withLoader && dispatch(beginAjaxCallAction());
      const rewardDealsResponse = await fetchBrandDealsApi({ url })
        .then((response) => {
          dispatch({
            type: FETCH_REWARD_DEALS,
            rewardDeals: get(response, 'data', {}),
          });
          return response;
        })
        .catch((errorResponse) => {
          dispatch(apiErrorResponseAction(get(errorResponse, 'response.data', {})));
          return get(errorResponse, 'response', {});
        });
      return rewardDealsResponse;
    } catch (error) {
      console.log(error);
    } finally {
      withLoader && dispatch(endAjaxCallAction());
    }
  };

export const fetchRewardPointsAction =
  ({ url }, withLoader = false) =>
  async (dispatch) => {
    try {
      withLoader && dispatch(beginAjaxCallAction());
      const rewardPointsResponse = await fetchRewardPointsApi({ url })
        .then((response) => {
          dispatch({
            type: FETCH_REWARD_POINTS,
            rewardPoints: get(response, 'data', {}),
          });
          return response;
        })
        .catch((errorResponse) => {
          dispatch(apiErrorResponseAction(get(errorResponse, 'response.data', {})));
          return get(errorResponse, 'response', {});
        });
      return rewardPointsResponse;
    } catch (error) {
      console.log(error);
    } finally {
      withLoader && dispatch(endAjaxCallAction());
    }
  };

export const initiateDeleteAccountAction =
  (requestBody, withLoader = false) =>
  async (dispatch) => {
    try {
      withLoader && dispatch(beginAjaxCallAction());
      const deleteAccountAPIResponse = await initiateDeleteAccountApi(requestBody)
        .then((response) => response)
        .catch((errorResponse) => {
          dispatch(apiErrorResponseAction(get(errorResponse, 'response.data', {})));
          return get(errorResponse, 'response', {});
        });

      return deleteAccountAPIResponse;
    } catch (err) {
      console.error(err);
    } finally {
      withLoader && dispatch(endAjaxCallAction());
    }
  };

export const initiateDeleteBrandGuestAccountAction =
  (requestBody, withLoader = false) =>
  async (dispatch) => {
    try {
      withLoader && dispatch(beginAjaxCallAction());
      const deleteRewardsAccountResponse = await initiateDeleteBrandGuestAccountApi(requestBody)
        .then((response) => response)
        .catch((errorResponse) => {
          dispatch(apiErrorResponseAction(get(errorResponse, 'response.data', {})));
          return get(errorResponse, 'response.data', {});
        });
      return deleteRewardsAccountResponse;
    } catch (err) {
      console.log(err);
    } finally {
      withLoader && dispatch(endAjaxCallAction());
    }
  };

export const updateGuestCouponFilterAction = (requestBody) => async (dispatch) => {
  try {
    dispatch({
      type: UPDATE_GUEST_COUPON_FILTER,
      filter: get(requestBody, 'filter', {}),
    });
  } catch (error) {
    console.log(error);
  }
};

export const updateRewardPointTransactionFilterAction = (requestBody) => async (dispatch) => {
  try {
    dispatch({
      type: UPDATE_REWARD_POINT_TRANSACTION_FILTER,
      filter: get(requestBody, 'filter', {}),
    });
  } catch (error) {
    console.log(error);
  }
};

export const dispatchCallbackUrlAction =
  ({ callbackUrl }) =>
  async (dispatch) => {
    dispatch({
      type: DISPATCH_CALLBACK_URL,
      callbackUrl,
    });
  };

export const updateSignupDetailsAction = (signupDetails) => async (dispatch) => {
  try {
    dispatch({ type: SIGNUP_DETAILS, signupDetails });
  } catch (error) {
    console.log(error);
  }
};

export const fetchVIPPassesAction =
  ({ url }) =>
  async (dispatch) => {
    try {
      const vipPassesResponse = await fetchVIPPassesApi({ url })
        .then((response) => {
          const vipPasses = get(response, 'data', {});
          dispatch({
            type: FETCH_VIP_PASSES,
            vipPasses,
          });

          return response;
        })
        .catch((errorResponse) => {
          dispatch(apiErrorResponseAction(get(errorResponse, 'response.data', {})));
          return get(errorResponse, 'response', {});
        });
      return vipPassesResponse;
    } catch (err) {
      console.error(err);
    }
  };

export const fetchVIPPassByIdAction =
  ({ passCode, brandGuestId }) =>
  async (dispatch) => {
    try {
      const vipPassDetailResponse = await fetchVIPPassByIdApi({ passCode, brandGuestId })
        .then((response) => {
          const vipPassDetail = get(response, 'data', {});
          dispatch({
            type: FETCH_VIP_PASS_DATA,
            vipPassDetail,
          });
          return response;
        })
        .catch((errorResponse) => {
          dispatch(apiErrorResponseAction(get(errorResponse, 'response.data', {})));
          return get(errorResponse, 'response', {});
        });
      return vipPassDetailResponse;
    } catch (err) {
      console.log(err);
    }
  };

export const fetchVIPPassCouponsByIdAction =
  ({ url }) =>
  async (dispatch) => {
    try {
      const vipPassCouponsResponse = await fetchVIPPassCouponsByIdApi({ url })
        .then((response) => {
          const vipPassCoupons = get(response, 'data', {});
          dispatch({
            type: FETCH_VIP_PASS_COUPONS,
            vipPassCoupons,
          });
          return response;
        })
        .catch((errorResponse) => {
          dispatch(apiErrorResponseAction(get(errorResponse, 'response.data', {})));
          return get(errorResponse, 'response', {});
        });
      return vipPassCouponsResponse;
    } catch (err) {
      console.log(err);
    }
  };

export const clearVIPPassDataAction = () => async (dispatch) => {
  dispatch({
    type: CLEAR_VIP_PASS_DATA,
  });
};

export const fetchPassMembershipsAction =
  ({ url }) =>
  async (dispatch) => {
    try {
      const passMembershipsResponse = await fetchPassMembershipsApi({ url })
        .then((response) => {
          const passMemberships = get(response, 'data', {});
          dispatch({
            type: FETCH_PASS_MEMBERSHIPS,
            passMemberships,
          });

          return response;
        })
        .catch((errorResponse) => {
          dispatch(apiErrorResponseAction(get(errorResponse, 'response.data', {})));
          return get(errorResponse, 'response', {});
        });
      return passMembershipsResponse;
    } catch (err) {
      console.log(err);
    }
  };

export const clearPassMembershipsAction = () => async (dispatch) => {
  dispatch({
    type: CLEAR_PASS_MEMBERSHIPS,
  });
};

export const fetchPassMembershipByIdAction =
  ({ membershipId, depth }) =>
  async (dispatch) => {
    try {
      const passMembershipResponse = await fetchPassMembershipByIdApi({ membershipId, depth })
        .then((response) => {
          const passMembership = get(response, 'data', {});
          dispatch({
            type: FETCH_PASS_MEMBERSHIP_BY_ID,
            passMembership,
          });
          return response;
        })
        .catch((errorResponse) => {
          dispatch(apiErrorResponseAction(get(errorResponse, 'response.data', {})));
          return get(errorResponse, 'response', {});
        });
      return passMembershipResponse;
    } catch (err) {
      console.log(err);
    }
  };

export const subscribePassMembershipAction =
  ({ subscribePassMembershipReqBody }) =>
  async (dispatch) => {
    try {
      const subscribedPassMembershipResponse = await subscribePassMembershipApi({
        subscribePassMembershipReqBody,
      })
        .then((response) => {
          const subscribedMembership = get(response, 'data', {});
          dispatch({
            type: DISPATCH_SUBSCRIBED_MEMBERSHIP,
            subscribedMembership,
          });
          return response;
        })
        .catch((errorResponse) => {
          dispatch(apiErrorResponseAction(get(errorResponse, 'response.data', {})));
          return get(errorResponse, 'response', {});
        });
      return subscribedPassMembershipResponse;
    } catch (err) {
      console.log(err);
    }
  };

export const fetchAllSubBrandAction = (payload) => async (dispatch) => {
  try {
    const subBrandsResponse = await fetchAllSubBrandsApi(payload)
      .then((response) => {
        dispatch({
          type: FETCH_ALL_SUB_BRANDS,
          subBrands: get(response, 'data', {}),
        });
        return response;
      })
      .catch((errorResponse) => {
        return errorResponse;
      });
    return subBrandsResponse;
  } catch (error) {
    console.log(error);
  }
};

export const updatePaymentCartAction =
  (payload, instantDealRedemption, withLoader = true) =>
  async (dispatch) => {
    try {
      withLoader && dispatch(beginAjaxCallAction());
      const updatePaymentCart = instantDealRedemption
        ? updatePaymentCartApiV2
        : updatePaymentCartApi;
      const paymentOrderResponse = await updatePaymentCart(payload)
        .then((response) => {
          dispatch({
            type: UPDATE_PAY_EARN_DATA,
            cart: { ...payload, ...get(response, 'data', {}) },
          });
          return response;
        })
        .catch((errorResponse) => {
          dispatch(apiErrorResponseAction(get(errorResponse, 'response.data', {})));
          return errorResponse;
        });

      return paymentOrderResponse;
    } catch (error) {
      console.log(error);
    } finally {
      withLoader && dispatch(endAjaxCallAction());
    }
  };

export const updatePayEarnDataAction = (payload) => async (dispatch) => {
  try {
    dispatch({
      type: UPDATE_PAY_EARN_DATA,
      payEarn: { ...payload },
    });
  } catch (error) {
    console.log(error);
  }
};

export const paymentOrderPayAction =
  (payload, instantDealRedemption, withLoader = true) =>
  async (dispatch) => {
    try {
      withLoader && dispatch(beginAjaxCallAction());
      const paymentOrderPay = instantDealRedemption ? paymentOrderPayApiV2 : paymentOrderPayApi;
      const paymentOrderPayResponse = await paymentOrderPay(payload)
        .then((response) => {
          dispatch({
            type: UPDATE_PAY_EARN_DATA,
            order: get(response, 'data', {}),
            cart: payload,
          });
          return response;
        })
        .catch((errorResponse) => {
          dispatch(apiErrorResponseAction(get(errorResponse, 'response.data', {})));
          return errorResponse;
        });

      return paymentOrderPayResponse;
    } catch (error) {
      console.log(error);
    } finally {
      withLoader && dispatch(endAjaxCallAction());
    }
  };

export const paymentOrderDetailsAction =
  (payload, withLoader = true) =>
  async (dispatch) => {
    try {
      withLoader && dispatch(beginAjaxCallAction());
      const paymentOrderPayResponse = await paymentOrderDetailsApi(payload)
        .then((response) => {
          dispatch({
            type: UPDATE_PAY_EARN_DATA,
            order: get(response, 'data', {}),
          });
          return response;
        })
        .catch((errorResponse) => {
          dispatch(apiErrorResponseAction(get(errorResponse, 'response.data', {})));
          return errorResponse;
        });

      return paymentOrderPayResponse;
    } catch (error) {
      console.log(error);
    } finally {
      withLoader && dispatch(endAjaxCallAction());
    }
  };

export const fetchReservationAvailableSlotsAction =
  (payload, withLoader = true) =>
  async (dispatch) => {
    try {
      withLoader && dispatch(beginAjaxCallAction());
      const availableSlotsResponse = await fetchReservationAvailableSlotsApi(payload)
        .then((response) => {
          dispatch({
            type: UPDATE_BOOK_TABLE_DATA,
            slots: get(response, 'data', {}),
          });
          return response;
        })
        .catch((errorResponse) => {
          dispatch(apiErrorResponseAction(get(errorResponse, 'response.data', {})));
          return errorResponse;
        });

      return availableSlotsResponse;
    } catch (error) {
      console.log(error);
    } finally {
      withLoader && dispatch(endAjaxCallAction());
    }
  };

export const createTableReservationAction =
  (payload) =>
  async (dispatch, withLoader = true) => {
    try {
      withLoader && dispatch(beginAjaxCallAction());

      const tableReservationResponse = await createTableReservationApi(payload)
        .then((response) => {
          dispatch({
            type: UPDATE_BOOK_TABLE_DATA,
            booking: get(response, 'data', {}),
          });
          return response;
        })
        .catch((errorResponse) => {
          return get(errorResponse, 'response', {});
        });
      return tableReservationResponse;
    } catch (error) {
      console.log(error);
    } finally {
      withLoader && dispatch(endAjaxCallAction());
    }
  };

export const fetchTableReservationDetailsAction =
  (payload, withLoader = true) =>
  async (dispatch) => {
    try {
      withLoader && dispatch(beginAjaxCallAction());

      const tableReservationResponse = await fetchTableReservationDetailsApi(payload)
        .then((response) => {
          dispatch({
            type: UPDATE_BOOK_TABLE_DATA,
            order: get(response, 'data', {}),
          });
          return response;
        })
        .catch((errorResponse) => {
          dispatch(apiErrorResponseAction(get(errorResponse, 'response.data', {})));
          return errorResponse;
        });

      return tableReservationResponse;
    } catch (error) {
      console.log(error);
    } finally {
      withLoader && dispatch(endAjaxCallAction());
    }
  };

export const updateBookTableDataAction = (payload) => async (dispatch) => {
  try {
    dispatch({
      type: UPDATE_BOOK_TABLE_DATA,
      bookTable: { ...payload },
    });
  } catch (error) {
    console.log(error);
  }
};

export const fetchGuestLastOrderAction =
  ({ url }, withLoader = false) =>
  async (dispatch) => {
    try {
      withLoader && dispatch(beginAjaxCallAction());
      const lastOrderResponse = await fetchGuestLastOrderApi({ url })
        .then((response) => {
          dispatch({
            type: FETCH_GUEST_LAST_ORDER,
            guestLastOrder: get(response, 'data', {}),
          });
          return response;
        })
        .catch((errorResponse) => {
          dispatch(apiErrorResponseAction(get(errorResponse, 'response.data', {})));
          return get(errorResponse, 'response', {});
        });
      return lastOrderResponse;
    } catch (error) {
      console.log(error);
    } finally {
      withLoader && dispatch(endAjaxCallAction());
    }
  };

export const validateReferralCodeAction =
  ({ validateReferralCodeReqBody }, withLoader = false) =>
  async (dispatch) => {
    try {
      withLoader && dispatch(beginAjaxCallAction());
      const response = await validateReferralCodeApi({ validateReferralCodeReqBody })
        .then((response) => {
          return response;
        })
        .catch((errorResponse) => {
          dispatch(apiErrorResponseAction(get(errorResponse, 'response.data', {})));
          return get(errorResponse, 'response', {});
        });
      return response;
    } catch (error) {
      console.log(error);
    } finally {
      withLoader && dispatch(endAjaxCallAction());
    }
  };

export const fetchReferralCodeAction =
  ({ brandGuestId }, withLoader = false) =>
  async (dispatch) => {
    try {
      withLoader && dispatch(beginAjaxCallAction());
      const response = await fetchReferralCodeApi({ brandGuestId })
        .then(async (response) => {
          dispatch({
            type: FETCH_REFERRAL_CODE,
            referralCode: get(response, 'data', {}),
          });
          return response;
        })
        .catch((errorResponse) => {
          return get(errorResponse, 'response', {});
        });
      return response;
    } catch (error) {
      console.log(error);
    } finally {
      withLoader && dispatch(endAjaxCallAction());
    }
  };

export const generateReferralCodeAction =
  ({ generateReferralCodeReqBody }, withLoader = false) =>
  async (dispatch) => {
    try {
      withLoader && dispatch(beginAjaxCallAction());
      const response = await generateReferralCodeApi({ generateReferralCodeReqBody })
        .then((response) => {
          dispatch({
            type: FETCH_REFERRAL_CODE,
            referralCode: get(response, 'data', {}),
          });
          return response;
        })
        .catch((errorResponse) => {
          dispatch(apiErrorResponseAction(get(errorResponse, 'response.data', {})));
          return get(errorResponse, 'response', {});
        });
      return response;
    } catch (error) {
      console.log(error);
    } finally {
      withLoader && dispatch(endAjaxCallAction());
    }
  };

export const fetchReferralDealsAction =
  ({ dealIds }) =>
  async (dispatch) => {
    const referrerDealIds = get(dealIds, 'referrer', []);
    const milestoneDealIds = get(dealIds, 'milestone', []);
    const gainerDealIds = get(dealIds, 'gainer', []);
    const allDealIds = Object.values(dealIds).flat();
    try {
      const referralDealDetailResponse = await fetchReferralDealsApi({ dealIds: allDealIds })
        .then((response) => {
          const referralDeals = get(response, 'data._embedded.deals', []);
          const referrerDeals = referralDeals.filter((deal) =>
            referrerDealIds.includes(get(deal, 'id')),
          );
          const gainerDeals = referralDeals.filter((deal) =>
            gainerDealIds.includes(get(deal, 'id')),
          );
          const milestoneDeals = referralDeals.filter((deal) =>
            milestoneDealIds.includes(get(deal, 'id')),
          );
          dispatch({
            type: FETCH_REFERRAL_DEALS,
            referralDeals: { referrerDeals, milestoneDeals, gainerDeals },
          });
          return response;
        })
        .catch((errorResponse) => {
          dispatch(apiErrorResponseAction(get(errorResponse, 'response.data', {})));
          return get(errorResponse, 'response', {});
        });
      return referralDealDetailResponse;
    } catch (err) {
      console.log(err);
    }
  };

export const fetchExternalOffersAction = (requestParams) => async (dispatch) => {
  try {
    const externalOffersResponse = await fetchExternalOffersApi(requestParams)
      .then((response) => {
        return response;
      })
      .catch((errorResponse) => {
        dispatch(apiErrorResponseAction(get(errorResponse, 'response.data', {})));
        return get(errorResponse, 'response.data', {});
      });
    return externalOffersResponse;
  } catch (error) {
    console.log(error);
  }
};

export const fetchExternalOfferDetailsAction = (offerId) => async (dispatch) => {
  try {
    const externalOffersResponse = await fetchExternalOfferDetailsApi(offerId)
      .then((response) => {
        return response;
      })
      .catch((errorResponse) => {
        dispatch(apiErrorResponseAction(get(errorResponse, 'response.data', {})));
        return get(errorResponse, 'response', {});
      });
    return externalOffersResponse;
  } catch (error) {
    console.log(error);
  }
};

export const fetchNearByHoodAction =
  ({ latitude, longitude }) =>
  async (dispatch) => {
    try {
      const nearByHoodResponse = await fetchNearByHoodApi({ latitude, longitude })
        .then((response) => {
          const applicableHoods = filterApplicableHoods(get(response, 'data', []));
          const hoodDetails = applicableHoods.find(Boolean);
          dispatch({
            type: FETCH_NEAYBY_HOOD,
            hoodDetails,
          });
          return { ...response, data: applicableHoods };
        })
        .catch((errorResponse) => {
          dispatch(apiErrorResponseAction(get(errorResponse, 'response.data', {})));
          return get(errorResponse, 'response', {});
        });
      return nearByHoodResponse;
    } catch (error) {
      console.log(error);
    }
  };

export const fetchHoodItemsByIdAction =
  ({ hoodId, hoodIds }) =>
  async (dispatch) => {
    try {
      const requestedHoodIds = getApplicableRequestedHoodIds({ hoodId, hoodIds });
      if (!requestedHoodIds.length) {
        dispatch({ type: FETCH_HOOD_ITEMS, hoodItems: [] });
        return { status: 200, data: [] };
      }
      const hoodItemsResponse = await Promise.all(
        requestedHoodIds.map((applicableHoodId) =>
          fetchHoodItemsByIdApi({ hoodId: applicableHoodId }),
        ),
      )
        .then((responses) => {
          const hoodItems = responses.reduce(
            (items, response, index) => [
              ...items,
              ...get(response, 'data', []).map((item) => ({
                ...item,
                hoodId: get(item, 'hoodId', requestedHoodIds[index]),
              })),
            ],
            [],
          );
          dispatch({
            type: FETCH_HOOD_ITEMS,
            hoodItems,
          });
          return { ...responses[0], data: hoodItems };
        })
        .catch((errorResponse) => {
          dispatch(apiErrorResponseAction(get(errorResponse, 'response.data', {})));
          return get(errorResponse, 'response', {});
        });
      return hoodItemsResponse;
    } catch (error) {
      console.log(error);
    }
  };

export const fetchHoodItemsByCatalogueAction =
  ({ hoodId, hoodIds }) =>
  async (dispatch) => {
    try {
      const requestedHoodIds = getApplicableRequestedHoodIds({ hoodId, hoodIds });
      if (!requestedHoodIds.length) {
        const hoodItemsCatalogue = { categories: [] };
        dispatch({ type: FETCH_HOOD_ITEMS_CATALOGUE, hoodItemsCatalogue });
        return { status: 200, data: hoodItemsCatalogue };
      }
      const hoodItemsCatalogueResponse = await Promise.all(
        requestedHoodIds.map((applicableHoodId) =>
          fetchHoodItemsByCatalogueApi({ hoodId: applicableHoodId }),
        ),
      )
        .then((responses) => {
          const hoodItemsCatalogue = mergeApplicableHoodCatalogues(
            responses.map((response, index) => ({
              hoodId: requestedHoodIds[index],
              catalogue: get(response, 'data', {}),
            })),
          );
          dispatch({
            type: FETCH_HOOD_ITEMS_CATALOGUE,
            hoodItemsCatalogue,
          });
          return { ...responses[0], data: hoodItemsCatalogue };
        })
        .catch((errorResponse) => {
          dispatch(apiErrorResponseAction(get(errorResponse, 'response.data', {})));
          return get(errorResponse, 'response', {});
        });
      return hoodItemsCatalogueResponse;
    } catch (error) {
      console.log(error);
    }
  };

export const onAddToCartAction =
  ({ cartItemReqBody }) =>
  async (dispatch) => {
    try {
      const addToCartResponse = await onAddToCartApi({ cartItemReqBody })
        .then((response) => {
          dispatch({
            type: ADD_TO_CART,
            cart: get(response, 'data', []),
            cartItem: cartItemReqBody,
          });
          return response;
        })
        .catch((errorResponse) => {
          dispatch(apiErrorResponseAction(get(errorResponse, 'response.data', {})));
          return get(errorResponse, 'response', {});
        });
      return addToCartResponse;
    } catch (error) {
      console.log(error);
    }
  };

export const removeItemFromCartAction =
  ({ hoodItemId }) =>
  async (dispatch) => {
    try {
      const removeItemFromCartResponse = await onRemoveFromCartApi({ hoodItemId })
        .then((response) => {
          dispatch({
            type: REMOVE_FROM_CART,
            cart: get(response, 'data', []),
          });
          return response;
        })
        .catch((errorResponse) => {
          dispatch(apiErrorResponseAction(get(errorResponse, 'response.data', {})));
          return get(errorResponse, 'response', {});
        });
      return removeItemFromCartResponse;
    } catch (error) {
      console.log(error);
    }
  };

export const clearCartAction = () => async (dispatch) => {
  try {
    const clearCartResponse = await clearCartApi()
      .then((response) => {
        dispatch({
          type: CLEAR_CART,
          cart: get(response, 'data', []),
        });
        return response;
      })
      .catch((errorResponse) => {
        dispatch(apiErrorResponseAction(get(errorResponse, 'response.data', {})));
        return get(errorResponse, 'response', {});
      });
    return clearCartResponse;
  } catch (error) {
    console.log(error);
  }
};

export const placeBookingAction =
  ({ bookingReqBody }) =>
  async (dispatch) => {
    try {
      dispatch({
        type: BEGIN_AJAX_CALL,
        showSpinner: true,
      });
      const placeBookingAPIResponse = await placeBookingApi({ bookingReqBody })
        .then((response) => {
          dispatch({
            type: PLACE_BOOKING,
            booking: get(response, 'data', {}),
          });
          return response;
        })
        .catch((error) => {
          dispatch(apiErrorResponseAction(get(error, 'response.data', {})));
          return get(error, 'response', {});
        });

      return placeBookingAPIResponse;
    } catch (err) {
      console.error(err);
    } finally {
      dispatch({
        type: END_AJAX_CALL,
        showSpinner: false,
      });
    }
  };

export const fetchHoodItemSlotsAction =
  ({ hoodItemId, date }) =>
  async (dispatch) => {
    try {
      const slotsResponse = await fetchHoodItemSlotsApi({ hoodItemId, date })
        .then((response) => {
          dispatch({
            type: FETCH_HOOD_ITEM_SLOTS,
            slots: get(response, 'data', []),
          });
          return response;
        })
        .catch((errorResponse) => {
          dispatch(apiErrorResponseAction(get(errorResponse, 'response.data', {})));
          return get(errorResponse, 'response', {});
        });
      return slotsResponse;
    } catch (error) {
      console.log(error);
    }
  };

export const resolveNearByHoodAction =
  ({ latitude, longitude }) =>
  async (dispatch) => {
    try {
      return await fetchNearByHoodApi({ latitude, longitude }).catch((errorResponse) => {
        dispatch(apiErrorResponseAction(get(errorResponse, 'response.data', {})));
        return get(errorResponse, 'response', {});
      });
    } catch (error) {
      console.log(error);
      return {};
    }
  };

const handleGroupedApiError = (dispatch, errorResponse) => {
  dispatch(apiErrorResponseAction(get(errorResponse, 'response.data', {})));
  return get(errorResponse, 'response', {});
};

export const clearCartStateAction = () => ({
  type: CLEAR_CART,
  cart: [],
});

export const clearCartSelectionStateAction = () => ({
  type: CLEAR_CART_SELECTION_STATE,
});

export const searchGroupedSlotsAction =
  ({ groupedSlotReqBody, groupKey, requestVersion }) =>
  async (dispatch) => {
    try {
      const response = await searchGroupedSlotsApi({ groupedSlotReqBody }).catch((error) =>
        handleGroupedApiError(dispatch, error),
      );
      if (apiResponseCodes.SUCCESS.includes(get(response, 'status'))) {
        dispatch({
          type: SEARCH_GROUPED_SLOTS,
          groupKey,
          requestVersion,
          request: groupedSlotReqBody,
          slotResponse: get(response, 'data', {}),
        });
      }
      return response;
    } catch (error) {
      console.error(error);
      return {};
    }
  };

export const replaceGroupedCartAction =
  ({ groupedCartReqBody }) =>
  async (dispatch) => {
    try {
      const response = await replaceGroupedCartApi({ groupedCartReqBody }).catch((error) =>
        handleGroupedApiError(dispatch, error),
      );
      if (apiResponseCodes.SUCCESS.includes(get(response, 'status'))) {
        dispatch({ type: REPLACE_GROUPED_CART, cart: get(response, 'data', {}) });
      }
      return response;
    } catch (error) {
      console.error(error);
      return {};
    }
  };

export const checkoutBookingOrderAction =
  ({ bookingOrderReqBody }) =>
  async (dispatch) => {
    dispatch({ type: BEGIN_AJAX_CALL, showSpinner: true });
    try {
      const response = await checkoutBookingOrderApi({ bookingOrderReqBody }).catch((error) =>
        handleGroupedApiError(dispatch, error),
      );
      if (apiResponseCodes.SUCCESS.includes(get(response, 'status'))) {
        dispatch({ type: CHECKOUT_BOOKING_ORDER, bookingOrder: get(response, 'data', {}) });
      }
      return response;
    } finally {
      dispatch({ type: END_AJAX_CALL, showSpinner: false });
    }
  };

export const clearGroupedCheckoutAction = () => ({ type: CLEAR_GROUPED_CHECKOUT });

export const updateGroupBookingDraftAction = ({ groupKey, changes }) => ({
  type: UPDATE_GROUP_BOOKING_DRAFT,
  groupKey,
  changes,
});

export const clearGroupBookingDraftAction = ({ groupKey }) => ({
  type: CLEAR_GROUP_BOOKING_DRAFT,
  groupKey,
});

export const initiateBookingOrderPaymentAction =
  ({ bookingOrderPaymentReqBody }) =>
  async (dispatch) => {
    dispatch({ type: BEGIN_AJAX_CALL, showSpinner: true });
    try {
      return await initiateBookingOrderPaymentApi({ bookingOrderPaymentReqBody }).catch((error) =>
        handleGroupedApiError(dispatch, error),
      );
    } finally {
      dispatch({ type: END_AJAX_CALL, showSpinner: false });
    }
  };

export const updateServiceSelectionAction =
  ({ selectionKey, hoodItemId, quantity }) =>
  (dispatch) => {
    dispatch({
      type: UPDATE_SERVICE_SELECTION,
      selectionKey,
      hoodItemId,
      quantity,
    });
  };

export const clearServiceSelectionAction =
  ({ selectionKey }) =>
  (dispatch) => {
    dispatch({
      type: CLEAR_SERVICE_SELECTION,
      selectionKey,
    });
  };

// Kept separate from the legacy item action so item-specific routes remain backward compatible.
export const fetchCategorySlotsAction =
  ({ hoodId, categoryId, subcategoryId, date }) =>
  async (dispatch) => {
    try {
      const slotsResponse = await fetchCategorySlotsApi({
        hoodId,
        categoryId,
        subcategoryId,
        date,
      })
        .then((response) => {
          dispatch({
            type: FETCH_CATEGORY_SLOTS,
            categorySlots: get(response, 'data', {}),
          });
          return response;
        })
        .catch((errorResponse) => {
          const errorData = get(errorResponse, 'response.data', {});
          dispatch(apiErrorResponseAction(errorData));
          return get(errorResponse, 'response', {});
        });
      return slotsResponse;
    } catch (error) {
      console.log(error);
    }
  };

export const fetchBookingHistoryAction =
  ({ url } = {}) =>
  async (dispatch) => {
    try {
      dispatch(beginAjaxCallAction());

      const bookingsResponse = await fetchBookingHistoryApi({ url })
        .then((response) => {
          const bookings = get(response, 'data', {});
          dispatch({
            type: FETCH_BOOKING_HISTORY,
            bookings,
          });

          return response;
        })
        .catch((errorResponse) => {
          dispatch(apiErrorResponseAction(get(errorResponse, 'response.data', {})));
          return get(errorResponse, 'response', {});
        });

      return bookingsResponse;
    } catch (err) {
      console.error(err);
    } finally {
      dispatch(endAjaxCallAction());
    }
  };

export const fetchBookingOrderDetailsAction =
  ({ orderId }) =>
  async (dispatch) => {
    try {
      dispatch(beginAjaxCallAction());
      const response = await fetchBookingOrderDetailsApi({ orderId }).catch((errorResponse) => {
        dispatch(apiErrorResponseAction(get(errorResponse, 'response.data', {})));
        return get(errorResponse, 'response', {});
      });
      if (apiResponseCodes.SUCCESS.includes(get(response, 'status'))) {
        dispatch({
          type: FETCH_BOOKING_ORDER_DETAILS,
          bookingOrderDetails: get(response, 'data', {}),
        });
      }
      return response;
    } finally {
      dispatch(endAjaxCallAction());
    }
  };

export const fetchBookingDetailsByIdAction =
  ({ bookingId }) =>
  async (dispatch) => {
    try {
      const bookingDetailsResponse = await fetchBookingDetailsByIdApi({ bookingId })
        .then((response) => {
          const bookingDetails = get(response, 'data', {});
          dispatch({
            type: FETCH_BOOKING_DETAILS,
            bookingDetails,
          });
          return response;
        })
        .catch((errorResponse) => {
          dispatch(apiErrorResponseAction(get(errorResponse, 'response.data', {})));
          return get(errorResponse, 'response', {});
        });
      return bookingDetailsResponse;
    } catch (err) {
      console.log(err);
    }
  };

export const fetchBookingFeedbackOptionsAction = ({ bookingId, rating }) => async () => {
  try {
    return await fetchBookingFeedbackOptionsApi({ bookingId, rating });
  } catch (errorResponse) {
    return get(errorResponse, 'response', {});
  }
};

export const fetchBookingFeedbackStatusAction = ({ bookingId }) => async () => {
  try {
    return await fetchBookingFeedbackStatusApi({ bookingId });
  } catch (errorResponse) {
    return get(errorResponse, 'response', {});
  }
};

export const createBookingFeedbackAction =
  ({ bookingId, bookingFeedbackReqBody }) =>
  async (dispatch) => {
    try {
      return await createBookingFeedbackApi({ bookingId, bookingFeedbackReqBody });
    } catch (errorResponse) {
      dispatch(apiErrorResponseAction(get(errorResponse, 'response.data', {})));
      return get(errorResponse, 'response', {});
    }
  };

export const fetchHoodItemsSlotsAction =
  ({ hoodId, hoodIds }) =>
  async (dispatch) => {
    try {
      const requestedHoodIds = getApplicableRequestedHoodIds({ hoodId, hoodIds });
      if (!requestedHoodIds.length) {
        dispatch({ type: FETCH_HOODD_ITEMS_SLOTS, hoodItemsSlots: [] });
        return { status: 200, data: [] };
      }
      const hoodItemsSlotsReponse = await Promise.all(
        requestedHoodIds.map((applicableHoodId) =>
          fetchEarlierSlotsAvailableByHoodIdApi({ hoodId: applicableHoodId }),
        ),
      )
        .then((responses) => {
          const hoodItemsSlots = responses.reduce(
            (slots, response) => [...slots, ...get(response, 'data', [])],
            [],
          );
          dispatch({
            type: FETCH_HOODD_ITEMS_SLOTS,
            hoodItemsSlots,
          });
          return { ...responses[0], data: hoodItemsSlots };
        })
        .catch((errorResponse) => {
          dispatch(apiErrorResponseAction(get(errorResponse, 'response.data', {})));
          return get(errorResponse, 'response', {});
        });
      return hoodItemsSlotsReponse;
    } catch (error) {
      console.log(error);
    }
  };

export const fetchUserConsentsAction = () => async (dispatch) => {
  try {
    const userConsentsResponse = await fetchUserConsentsApi()
      .then((response) => {
        const userConsents = get(response, 'data', []);
        dispatch({
          type: FETCH_USER_CONSENTS,
          userConsents,
        });
        return response;
      })
      .catch((errorResponse) => {
        dispatch(apiErrorResponseAction(get(errorResponse, 'response.data', {})));
        return get(errorResponse, 'response', {});
      });
    return userConsentsResponse;
  } catch (error) {
    console.log(error);
  }
};

export const updateUserConsentsAction =
  ({ userConsentsReqBody }, withLoader = true) =>
  async (dispatch) => {
    try {
      if (withLoader) {
        dispatch(beginAjaxCallAction());
      }
      const updateUserConsentsResponse = await updateUserConsentsApi({
        updateUserConsentsReqBody: userConsentsReqBody,
      })
        .then((response) => {
          dispatch({
            type: UPDATE_USER_CONSENTS,
            userConsents: get(response, 'data', {}),
          });
          return response;
        })
        .catch((errorResponse) => {
          dispatch(apiErrorResponseAction(get(errorResponse, 'response.data', {})));
          return get(errorResponse, 'response', {});
        });
      return updateUserConsentsResponse;
    } catch (error) {
      console.log(error);
    } finally {
      if (withLoader) {
        dispatch(endAjaxCallAction());
      }
    }
  };

export const updateCartWithUserConsentAction =
  (userConsent, withLoader = true) =>
  async (dispatch) => {
    try {
      if (withLoader) {
        dispatch(beginAjaxCallAction());
      }
      const updateUserConsentsResponse = await updateCartWithUserConsentApi(userConsent)
        .then((response) => {
          return response;
        })
        .catch((errorResponse) => {
          dispatch(apiErrorResponseAction(get(errorResponse, 'response.data', {})));
          return get(errorResponse, 'response', {});
        });
      return updateUserConsentsResponse;
    } catch (error) {
      console.log(error);
    } finally {
      if (withLoader) {
        dispatch(endAjaxCallAction());
      }
    }
  };
